import { ArrowLeft } from '@wix/wix-ui-icons-common';
import React, { FC, useCallback } from 'react';
import { useStore } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { logBackButtonAction } from '../../../bi';
import { useCurrentPage } from '../../../common/hooks/useCurrentPage';
import { appRoutes } from '../../../routes';
import { renderModel } from '../../../util/renderModel';
import { HeaderActionsIcon } from '../HeaderActions/HeaderActionsIcon';
import { backButtonDataHooks } from './BackButton.dataHooks';

const isLandingPage = renderModel.isLandingPage();
const backButtonRoute = isLandingPage ? appRoutes.chatbot() : appRoutes.home();

type BackButtonProps = { isNewBehaviourEnabled: boolean };

export const BackButton: FC<BackButtonProps> = ({ isNewBehaviourEnabled = false }) => {
  const store = useStore();
  const currentPage = useCurrentPage();
  const navigate = useNavigate();
  const location = useLocation();

  const goBack = useCallback(() => {
    const state = store.getState();

    logBackButtonAction(state, { currentPage });

    if (isNewBehaviourEnabled) {
      navigate(-1);
    } else {
      navigate(backButtonRoute);
    }
  }, [store, navigate, currentPage, isNewBehaviourEnabled]);

  if (location.pathname === backButtonRoute) {
    // DO not show this Back Button on Homepage
    return null;
  }

  return (
    <HeaderActionsIcon onClick={goBack} dataHook={backButtonDataHooks.backButton()}>
      <ArrowLeft />
    </HeaderActionsIcon>
  );
};
